// extracted by mini-css-extract-plugin
export default {"Periode":"PageListePeriodes_Periode__pgkSB","Titre":"PageListePeriodes_Titre__W77HM","BoutonRetour":"PageListePeriodes_BoutonRetour__Jdhb4"};